import React from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { appUrl } from 'utils';
import { _T } from 'appI18n';
export default function TourSearchResultsHeader({ variant, searchResult, searchQuery }) {
    const history = useHistory();
    // XXX: полон хаков.
    return React.createElement(React.Fragment, null,
        variant != 'description' ? React.createElement("h1", null, searchResult.searchLocation) : null,
        variant == 'description' ?
            React.createElement("a", { onClick: () => history.goBack(), className: "back-to-search", href: "#" },
                React.createElement("i", { className: "fa fa-angle-left", "aria-hidden": "true" }),
                " ",
                _T.COMMON_TOSEARCHRESULTS) : null,
        React.createElement("div", { className: "row mb-4" },
            React.createElement("div", { className: "col-md-9" },
                variant == 'description' ? React.createElement("div", { className: "col-xs-12 col-md-2" }) : null,
                variant != 'description' ?
                    React.createElement("div", { className: "col-xs-12 col-md-2 hotels-number" },
                        React.createElement("span", null, _T.TOUR_TOURSFOUND),
                        React.createElement("span", { className: "count" }, searchResult.totalCount)) : null,
                React.createElement("div", { className: "col-xs-12 col-md-10 steps" },
                    React.createElement("ul", { className: "list-inline" },
                        React.createElement("li", { className: "active" },
                            React.createElement("span", { className: "step-number" }, "1"),
                            React.createElement("span", { className: "step-text" }, _T.COMMON_SEARCHRESULT)),
                        React.createElement("li", null,
                            React.createElement("span", { className: "step-number" }, "2"),
                            " ",
                            React.createElement("span", { className: "step-text" }, _T.COMMON_BASKET),
                            " "),
                        React.createElement("li", null,
                            React.createElement("span", { className: "step-number" }, "3"),
                            " ",
                            React.createElement("span", { className: "step-text" }, _T.COMMON_BOOKING)))))),
        variant != 'description' ? (React.createElement("div", { className: "row mb-4" },
            React.createElement("div", { className: "col-md-3" },
                React.createElement("a", { href: appUrl('/Tour'), className: "btn btn-orange w-100 py-3 text-uppercase" },
                    React.createElement("i", { className: "fa fa-search", "aria-hidden": "true" }),
                    " ",
                    _T.COMMON_NEWSEARCH)),
            React.createElement("div", { className: "col-md-9 hotel-info m-0 py-3" },
                React.createElement("div", { className: "hotel-info-item" },
                    React.createElement("span", null,
                        _T.COMMON_COUNTRY,
                        ":"),
                    " ",
                    React.createElement("span", null, searchResult.searchCountry)),
                React.createElement("div", { className: "hotel-info-item" },
                    React.createElement("span", null,
                        _T.COMMON_DATE,
                        ":"),
                    React.createElement("span", null,
                        moment(searchQuery['cimin']).format('L'),
                        " - ",
                        moment(searchQuery['cimax']).format('L'))),
                React.createElement("div", { className: "hotel-info-item" },
                    React.createElement("span", null,
                        _T.COMMON_DURATION,
                        ":"),
                    React.createElement("span", null, searchQuery['dmin'] != searchQuery['dmax']
                        ? `${searchQuery['dmin']} - ${searchQuery['dmax']}`
                        : searchQuery['dmin']))))) : null);
}
